import { Text, Avatar, Container, Row, Spacer } from '@nextui-org/react'
import React, {useState} from 'react'
import { useNavigate } from 'react-router-dom';
import {BsFillGearFill} from 'react-icons/bs';
import useAuth from '../Hooks/useAuth';

const NavBar = () => {
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();
  const {user, loading} = useAuth();

  const handler = () => {
    navigate('/profile')
  };

  return (
    <Container
        css={{
            shadow: "$lg",
            borderRadius: '$2xl',
            color: '$white',
            py: '$2',
            mt: '$2',
        }}
    >
        <Row>
            <Text h3 css={{alignSelf: "center", mt: '$3'}}>Bonjour, </Text>
            <Spacer/>
            {
              hover ?
                <Avatar 
                  onClick={handler}
                  icon={<BsFillGearFill size={"30"}/>}
                  pointer
                  size="xl"
                  color="primary" 
                  textColor="white"
                  onMouseLeave={() => setHover(false)}      

                />
                :
                <Avatar 
                  onClick={handler}
                  text={user?.firstname}
                  pointer
                  size="xl"
                  color="gradient" 
                  textColor="white" 
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}      
               />
          }
        </Row>

    </Container>
  )
}

export default NavBar